'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _iconBase = require('./icon.base64.js');

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var dom = weex.requireModule('dom');

var MIN_DISTANCE = 30;
exports.default = {
  name: 'StarRate',
  mixins: [_colmo2.default, _diablo2.default],
  components: {
    DofIconfont: _dofIconfont2.default
  },
  props: {
    curScore: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'big'
    },
    allowHalf: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      score: '',
      imgStarOn: _iconBase.bigFill,
      imgStarHalf: _iconBase.bigHalf,
      imgStarOff: _iconBase.bigBlank,
      colmoImgStarOn: _iconBase.bigColmoFill,
      colmoImgStarOff: _iconBase.bigColmoBlank,
      colmoImgStartHalf: _iconBase.bigColmoHalf,
      starOffsetLeft: 0, // 包裹星星的div的X坐标
      startX: 0,
      startY: 0,
      deltaX: 0,
      offsetY: 0,
      direction: '',
      starWidth: 0,
      lastMoveStamp: 0,
      finalScore: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.score = this.curScore;
  },

  computed: {
    iconSize: function iconSize() {
      var map = {
        big: 64,
        mid: 56,
        small: 32
      };
      return map[this.size];
    }
  },
  watch: {
    score: function score(newVal, oldVal) {
      var _this = this;

      //延迟500ms比较最新的分数，如果newVal==this.curScore，表示滑动已结束
      var timeOut = setTimeout(function () {
        if (newVal == _this.curScore) {
          // console.log('newVal:'+newVal+" curScore:"+this.curScore)
          _this.finalScore = _this.curScore;
          var data = { score: _this.finalScore, type: 'touchEnd' };
          _this.$emit('setScore', data);
          clearTimeout(timeOut);
        }
      }, 100);
    }
  },
  methods: {
    setScore: function setScore(score) {
      this.curScore = score;
      this.score = score;
      var data = { score: this.score, type: 'click' };
      this.$emit('setScore', data);
    },
    getDirection: function getDirection(x, y) {
      if (x > y && x > MIN_DISTANCE) {
        return 'horizontal';
      }
      if (y > x && y > MIN_DISTANCE) {
        return 'vertical';
      }
      return '';
    },
    resetTouchStatus: function resetTouchStatus() {
      this.direction = '';
      this.deltaX = 0;
      this.deltaY = 0;
      this.offsetX = 0;
      this.offsetY = 0;
    },
    touchStart: function touchStart(evt) {
      var self = this;
      if (self.disabled) return;
      self.resetTouchStatus();
      if (evt && evt.changedTouches.length === 1) {
        self.startX = evt.changedTouches[0].pageX;
        self.startY = evt.changedTouches[0].pageY;
      }
    },
    touchMove: function touchMove(evt) {
      var self = this;
      var now = new Date().getTime();
      var timeDiff = now - self.lastMoveStamp;
      //设置滑动更新数据间隔时间，避免频繁更新数据，导致安卓上渲染星星src失败
      if (timeDiff < 40 || self.disabled) return;
      self.lastMoveStamp = now;
      //首次滑动时，获取星星组件width和offsetLeft,并且保存，避免每次滑动时都获取组件width和offsetLeft
      if (!self.starWidth) {
        var el = this.$refs.star;
        dom.getComponentRect(el, function (options) {
          if (options.result && options.size.left) {
            self.starWidth = options.size.width / 5;
            self.starOffsetLeft = options.size.left;
            self.setTouchScore(evt);
          }
        });
      } else {
        self.setTouchScore(evt);
      }
    },
    setTouchScore: function setTouchScore(evt) {
      var self = this;
      if (evt && evt.changedTouches.length === 1) {
        self.deltaX = evt.changedTouches[0].pageX - self.startX;
        self.deltaY = evt.changedTouches[0].pageY - self.startY;
        self.offsetX = Math.abs(self.deltaX);
        self.offsetY = Math.abs(self.deltaY);
        self.direction = self.direction || self.getDirection(self.offsetX, self.offsetY);
        if (self.direction == 'horizontal') {
          var distanceX = evt.changedTouches[0].screenX - self.starOffsetLeft + 40;
          var starNum = distanceX / self.starWidth;
          if (starNum > 5) {
            starNum = 5;
          } else if (starNum >= 0.4 && starNum <= 0.5) {
            //<=0.5
            starNum = 0.5;
          } else if (starNum < 0.4) {
            // 解决半星滑动操作时，不能清空星星的问题
            starNum = 0;
          } else {
            if (starNum >= Math.floor(starNum) && starNum < Math.floor(starNum) + 0.5) {
              starNum = Math.floor(starNum);
            } else {
              starNum = Math.floor(starNum) + 0.5;
            }
          }
          self.curScore = starNum;
          self.score = starNum;
          // console.log("touchmove:"+starNum)
          var data = { score: starNum, type: 'touchMove' };
          self.$emit('setScore', data);
        }
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-rate/index.vue
// module id = 371
// module chunks = 0 1